import { render } from "./LoginUnicoCallback.vue?vue&type=template&id=430fcb4b&scoped=true"
import script from "./LoginUnicoCallback.vue?vue&type=script&lang=js"
export * from "./LoginUnicoCallback.vue?vue&type=script&lang=js"

import "./LoginUnicoCallback.vue?vue&type=style&index=0&id=430fcb4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430fcb4b"]])

export default __exports__